import { render, staticRenderFns } from "./PersonalBanner.vue?vue&type=template&id=2f24d4a2&scoped=true"
import script from "./PersonalBanner.vue?vue&type=script&lang=js"
export * from "./PersonalBanner.vue?vue&type=script&lang=js"
import style0 from "./PersonalBanner.vue?vue&type=style&index=0&id=2f24d4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24d4a2",
  null
  
)

export default component.exports